import React from 'react';
import { styled } from '@compiled/react';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { token } from '@atlaskit/tokens';
import { type LinkWithAnalyticsProps, LinkWithAnalytics } from '../link';

export const ExternalLinkWithAnalytics = ({
	children,
	href,
	actionSubjectId,
	attributes = {},
}: LinkWithAnalyticsProps) => (
	<InlineLinkWithAnalytics
		target="_blank"
		attributes={attributes}
		href={href}
		actionSubjectId={actionSubjectId}
	>
		{children}
		<IconContainer>
			<ShortcutIcon size="small" label="" />
		</IconContainer>
	</InlineLinkWithAnalytics>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const InlineLinkWithAnalytics = styled(LinkWithAnalytics)({
	display: 'inline-block',
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconContainer = styled.div<any>({
	display: 'inline-block',
	marginLeft: token('space.050', '4px'),
	verticalAlign: 'middle',
});
